import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NonAuthRoutes, RouteParamsTypes, Modules, AuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import MyAccount from '../modules/my/account';

const My: React.FC = () => {
  return (
    <Routes>
      <Route
        path={AuthRoutes.profile}
        element={<Navigate replace to={`${Modules.my}${AuthRoutes.account}?tab=profile`} />}
      />
      <Route path={AuthRoutes.account} element={<ProtectedRoute component={MyAccount} />} />
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default My;
